const DISABLED_FIELDS = ['username', 'email', 'phoneNumber'];

export const shouldDisableField = (
  fieldName: string,
  formValues: { [key: string]: any } | boolean | undefined,
  currentDisabled?: boolean
): boolean => {
  
  if (typeof formValues === 'boolean') {
    console.log(`[shouldDisableField] ${fieldName}: boolean value =`, formValues);
    return formValues;
  }
  
  if (!formValues || typeof formValues !== 'object') {
    if (fieldName === 'email') {
      console.log(`[shouldDisableField] ${fieldName}: email field, returning false`);
      return false;
    }
    
    const result = !!currentDisabled || DISABLED_FIELDS.includes(fieldName);
    console.log(`[shouldDisableField] ${fieldName}: no formValues, result =`, result);
    return result;
  }
  
  const {email, phoneNumber} = formValues;
  
  if (fieldName === 'email') {
    const result = email !== undefined && email !== '';
    console.log(`[shouldDisableField] ${fieldName}: email field, value =`, email, 'result =', result);
    return result;
  } else if (fieldName === 'phoneNumber') {
    const result = phoneNumber !== undefined && phoneNumber !== '';
    console.log(`[shouldDisableField] ${fieldName}: phoneNumber field, value =`, phoneNumber, 'result =', result);
    return result;
  }
  
  if (DISABLED_FIELDS.includes(fieldName)) {
    console.log(`[shouldDisableField] ${fieldName}: in DISABLED_FIELDS, returning true`);
    return true;
  }
  
  const result = !!currentDisabled;
  console.log(`[shouldDisableField] ${fieldName}: fallback, currentDisabled =`, currentDisabled, 'result =', result);
  return result;
};
